import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { map, Observable } from 'rxjs';

import { SelectOption } from '@fcom/common';
import { LanguageService } from '@fcom/ui-translate';
import { UserDetailsForm } from '@fcom/common/interfaces/corporate/corporate.interface';

@Component({
  selector: 'fin-user-details-form',
  templateUrl: './user-details-form.component.html',
})
export class UserDetailsFormComponent implements OnInit {
  roles$: Observable<SelectOption[]>;

  @Input() formGroup: FormGroup<UserDetailsForm>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.roles$ = this.languageService
      .translateMultiple([
        'CORPORATE.corporatePortal.roles.A',
        'CORPORATE.corporatePortal.roles.T',
        'CORPORATE.corporatePortal.roles.B',
      ])
      .pipe(
        map((translations) => [
          { name: translations[0], value: 'A' },
          { name: translations[1], value: 'T' },
          { name: translations[2], value: 'B' },
        ])
      );
  }
}
